import type { ComponentType, JSX } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import clsx from 'clsx';

export interface ActionCardProps {
  title: string;
  description: string;
  to: string;
  icon?: ComponentType<{ className?: string }>;
  badge?: string;
  ctaLabel?: string;
  className?: string;
}

export function ActionCard({
  title,
  description,
  to,
  icon: Icon,
  badge,
  ctaLabel = 'Open',
  className,
}: ActionCardProps): JSX.Element {
  return (
    <Link
      to={to}
      className={clsx(
        'group flex h-full flex-col gap-sm rounded-2xl border border-surface-subtle bg-white/90 p-6 text-left shadow-card transition hover:-translate-y-0.5 hover:border-brand-primary/40 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2',
        className,
      )}
    >
      {typeof badge === 'string' && badge.length > 0 ? (
        <span className="inline-flex w-fit items-center rounded-full bg-brand-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-primary">
          {badge}
        </span>
      ) : null}
      <div className="flex items-center gap-2">
        {Icon ? <Icon aria-hidden="true" className="h-5 w-5 text-brand-primary" /> : null}
        <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
      </div>
      <p className="text-sm leading-relaxed text-text-primary/70">{description}</p>
      <span className="mt-auto inline-flex items-center gap-1 text-sm font-semibold text-brand-primary">
        {ctaLabel}
        <ArrowRightIcon
          aria-hidden="true"
          className="h-4 w-4 transition-transform group-hover:translate-x-1"
        />
      </span>
    </Link>
  );
}
